export default {
      id: "spinner-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#spinner",
      toString: function () {
        return this.url;
      }
    }